import React from "react";
import { useFunnelNavigation } from "../../../hooks/useFunnelNavigation";
import { StepHeader } from "../../common/StepHeader";
import { InfoBox } from "../../common/InfoBox";
import { Footer } from "../../common/Footer";

export function ImageLayout({ config }) {
  const { nextStep } = useFunnelNavigation();

  return (
    <div className="px-4">
      <div className="flex-1">
        <StepHeader
          title={config.title}
          subtitle={config.subtitle}
          order={config.headerOrder}
        />

        <div className="flex-1 flex flex-col items-center pt-2 space-y-4">
          <div className="relative w-full max-w-md p-2">
            <img
              src={config.imageUrl}
              alt={config.title}
              className="w-full h-full object-contain rounded-2xl"
            />
          </div>

          {config.infoBox && (
            <InfoBox
              variant={config.infoBox.variant || "info"}
              icon={config.infoBox.icon}
              title={config.infoBox.title}
              text={config.infoBox.text}
              badge={config.infoBox.badge}
              className="max-w-md"
            />
          )}
        </div>
      </div>

      <Footer onClick={nextStep}>{config.buttonText || "Next"}</Footer>
    </div>
  );
}
